import { render, staticRenderFns } from "./number-field.vue?vue&type=template&id=485ee5bc&scoped=true&"
import script from "./number-field.vue?vue&type=script&lang=ts&"
export * from "./number-field.vue?vue&type=script&lang=ts&"
import style0 from "./number-field.vue?vue&type=style&index=0&id=485ee5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ee5bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
